import { Injectable } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';
import { EnvironmentService } from '../utility/environment.service';

export interface DoremonFile{
  id: number;
  key: string;
  name: string;
}

@Injectable({
  providedIn: 'root'
})
export class DoremonService {

  private readonly doremonUrl: string;
  private readonly doremonDocKey: string;
  private _sessionToken:string = '';
  private headers = {};

  constructor(
    private authService: AuthService,
    private http: HttpClient,
    private environmentService: EnvironmentService
  ) { 
    this._sessionToken = this.authService.sessionToken;
    this.headers = new HttpHeaders().set('Authorization', this._sessionToken);
    this.doremonUrl = this.environmentService.getDoremonUrl();
    this.doremonDocKey = this.environmentService.doremonDocKey;
  }

  uploadFile(file:any) {
      var formdata = new FormData();
      formdata.append("file", file, file.name);

      return this.http
      .post<any>(`${this.doremonUrl}/doraemon/api/v1/document`, formdata)
      .pipe(
          catchError(this.authService.handleError.bind(this))
      );
  }

  private downloadDocApiCall(id: number, key: string, view: boolean): Observable<Blob> {
    const httpOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        'Authorization': this.doremonDocKey,
      })
    };
    return this.http
      .get<Blob>(this.doremonUrl + '/doraemon/api/v1/document/' + id + '/' + key + `?view=${view}`,
        httpOptions,
      ) as Observable<Blob>;
  }

  downloadDoc(name: string, id: number, key: string, view: boolean) {
    const fileExtension = name.split('.').pop()?.toLowerCase();
    if (fileExtension != 'pdf') {
      view = false;
    }
    this.downloadDocApiCall(id, key, view)
      .subscribe((data: any) => {
        if (!data) {
          return;
        }
        let fileType;
        switch (fileExtension) {
          case 'xlsx':
            fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64"
            break;
          case 'pdf':
            fileType = "application/pdf"
            break;
          case 'png':
            fileType = "image/png"
            break;
          case 'jpeg':
            fileType = "image/jpeg"
            break;
          case 'jpg':
            fileType = "image/jpg"
            break;
          default:
            fileType = "application/pdf"
            break;
        }
        // let fileType = type ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," : 'application/pdf'; 
        let file = new Blob([data], { type: fileType })

        let fileURL = URL.createObjectURL(file);
        // if you want to open PDF in new tab
        if (view && fileExtension != 'xlsx') {
          window.open(fileURL);
        }
        var a = document.createElement('a');
        a.href = fileURL;
        // a.target = view ? '_blank' : '';
        a.download = name;
        document.body.appendChild(a);
        a.click();
      });
  }

}
